import { Box, Button, Flex, Heading, Input, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useDebouncedFieldRegistry } from '@/utils/filterUtils/useDebouncedFieldRegistry';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { AccessControlFilters } from '../../types';
import { t } from '@/i18n';

export interface AccessControlFiltersBoxProps {
  filtersForm: UseFormReturn<AccessControlFilters>;
  forceRefetch: () => void;
}

export const AccessControlFiltersBox = ({ filtersForm }: AccessControlFiltersBoxProps) => {
  const { register, reset } = filtersForm;

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle' fontWeight='semibold'>
          {t('pages.access_control.components.filter_box.heading')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'row' }} gap='small' rowGap='micro'>
        <SimpleGrid gap='deka' alignItems='flex-end' columns={{ base: 1, md: 4, xl: 6, '10xl': 6 }} rowGap='xxsmall' flexGrow={1}>
          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'> {t('pages.access_control.components.filter_box.label_user')}</Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('name'))} />
          </InputGroup>
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.access_control.components.filter_box.button_clear')}
        </Button>
      </Flex>
    </Box>
  );
};
